import React from 'react';
import ButtonCard from '../../BuildingBlocks/Button/ButtonCard';
import Button from '../../BuildingBlocks/Button/Button';
import { makeStyles } from '@material-ui/core/styles';
import { actions, steps } from './Dialog';
import { useLinesContext } from '../../../contexts/Lines';
import { lineStatus } from '../../../utils/enums';

const useStyles = makeStyles((theme: any) => ({
  buttonsMargin: {
    '& .MuiTypography-paragraph': {
      marginBottom: theme.spacing(0),
    },
    '& .MuiButton-root:hover': {
      backgroundColor: theme.palette.primary.light,
      border: `1px solid ${theme.palette.brand.blueSky}`,
    },
  },
  container: {
    textAlign: 'center',
  },
}));

export default function Types({
  changedRequestInfo,
  setStepNumber,
  setOptionNumber,
}) {
  const classes = useStyles();
  const { selectedLine } = useLinesContext();
  const completeOriginLine = selectedLine?.status === lineStatus.complete;
  const lineChanged =
    changedRequestInfo.LineDateChanged || changedRequestInfo.LineDetailsChanged;

  return (
    <div className={classes.container}>
      <div className={classes.buttonsMargin}>
        <ButtonCard
          header={'Line dates, costs, or units'}
          subHeader={
            'e.g. A shipment delay, increase in freight costs, change to order size, etc.'
          }
          onClick={() => setStepNumber(steps.editStages)}
        />

        <ButtonCard
          header={'Adjust my remittance schedule'}
          subHeader={'e.g. Sales have slowed or sped up.'}
          onClick={() => setStepNumber(steps.adjustMyRemittanceSchedule)}
        />

        {!lineChanged && !completeOriginLine && (
          <ButtonCard
            header={'Cancel an entire Line'}
            subHeader={'e.g. The Line, or financing, are no longer needed.'}
            onClick={() => setOptionNumber(actions.cancelLine)}
          />
        )}

        <ButtonCard
          header={'Something else'}
          onClick={() => setStepNumber(steps.somethingElse)}
        />
      </div>
      {lineChanged && (
        <Button
          variant="contained"
          color="primary"
          onClick={() => setStepNumber(steps.addMessage)}
        >
          I want to submit as is
        </Button>
      )}
    </div>
  );
}
